<template>
    <van-popup
        id="send-message"
        v-model="visible"
        position="bottom"
    >
        <van-cell-group>
            <van-field
                v-model="message"
                rows="8"
                type="textarea"
                label=""
                label-width="0"
                :placeholder="placeholder"
            />
            <van-button type="default" :block="true" class="btn" @click="onSend">确定</van-button>
        </van-cell-group>
    </van-popup>
</template>

<script>
import { Popup,CellGroup,Cell,Field, Button } from 'vant';
export default {
    name: 'SendMessage',
    components: {
        [Popup.name]: Popup,
        [CellGroup.name]: CellGroup,
        [Cell.name]: Cell,
        [Field.name]: Field,
        [Button.name]: Button
    },
    data() {
        return {
            visible: false,
            placeholder: '',
            message: ''
        }
    },
    methods: {
        show(placeholderMsg) {
            this.placeholder = placeholderMsg
            this.visible = true
        },
        hide() {
            this.visible = false
            this.message = ''
        },
        onSend() {
            this.$emit('sendMsg', { msg: this.message })
        }
    }
}
</script>

<style lang="less" scope>
#send-message {
    padding-left: 8px;
    padding-right: 8px;
    padding-top: 8px;

    .btn {
        margin-top: 16px;
    }
}
</style>